import { asignarPodador, getPodadores, getPodadoresPublic } from "../services/podadores.service";
import { useFormActaStore } from "../store/formActaStore";
import { useGeneralAppStore } from "../store/generalAppStore";
import { usePodadoresStore } from "../store/podadoresStore";

const { setPodadores } = usePodadoresStore.getState();
const { handlerModal } = useGeneralAppStore.getState();
const { setDefaultValues } = useFormActaStore.getState();

export const getPodadoresHandler = async () => {
  const result = await getPodadores();
  if (result) {
    setPodadores(result);
    handlerModal({ modal: true, modalName: "podadores" });
  }
};

export const getPodadoresPublicHandler = async () => {
  const result = await getPodadoresPublic();
  if (result) {
    setPodadores(result);
    handlerModal({ modal: true, modalName: "podadores" });
  }
};

export const asignarPodadorHandler = async (payload) => {
  const { podadores } = payload;
  const podadoresID = podadores.map((podador) => {
    return podador.id;
  });
  payload.podadores = podadoresID;
  const result = await asignarPodador(payload);
  if (result) {
    setDefaultValues(result);
    handlerModal({ modal: false, modalName: "asignar_podadores" });
    handlerModal({ modal: false, modalName: "podadores" });
  }
};
